import React from 'react';
import CardItem from './CardItem';
import './Cards.css';

function Cards() {
  return (
<div className="cards" id='hero'>
    <h1>PROGDRUMMER</h1>
    <div className="cards__container">
        <div className="cards__wrapper">
            <ul className="cards__items">
                <CardItem
                src='image/Prog.jpg' 
                text='Computer programmer front-end'
                label='Career'
                />
                <CardItem
                src='image/Drum.jpg' 
                text='CTKC and ICS drummer'
                label='Music'
                />
                <CardItem
                src='image/Mer.jpg' 
                text='Online video gamer MOBA / FPS'
                label='Hobby'
                />
            </ul>
        </div>
    </div>
</div>
  )
}

export default Cards